import type { FC } from 'react'
import dynamic from 'next/dynamic'
import FilterFeedback from './FilterFeedback'
import { useDealFilters } from '../../DealFiltersProvider'
import type { TickFilter } from '@g4g/utils/src/types'
import ClearAllButton from './ClearAllButton'
const DesktopSortOptions = dynamic(() => import('./DesktopSortOptions'))

const DesktopDealsHeader: FC<{ category: TickFilter[]; resource: TickFilter[] }> = ({
  category,
  resource,
}) => {
  const { categories, resources, sortBy } = useDealFilters()
  const activeFiltersCount = categories.size + resources.size

  return (
    <>
      <div className="flex flex-wrap w-full">
        {activeFiltersCount > 0 && (
          <>
            {[...Array.from(categories), ...Array.from(resources)].map((id) => (
              <FilterFeedback
                key={id}
                filter={[...category, ...resource].find((filter) => filter.id === id)}
                trait={categories.has(id) ? 'category' : 'resource'}
              />
            ))}
            <ClearAllButton />
          </>
        )}
      </div>
      <DesktopSortOptions sortBy={sortBy} />
    </>
  )
}

export default DesktopDealsHeader
